import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {SensorSummary} from '../overview/model/sensor-overview.model';
import {SensorService} from '../service/sensor.service';

@Injectable()
export class SensorSummaryResolver {

  constructor(private sensorService: SensorService,
              private logger: NGXLogger) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<SensorSummary[]> {
    this.logger.debug('SensorSummaryResolver: Waiting for sensor summaries to be available.');

    return this.sensorService.getAllSensorSummaries();
  }
}
